export default "__VITE_ASSET__kdGdO16I__"